import { useEffect, useState } from "react";
import { feedingsApi } from "../../services/feedingsApi";
import { exportApi } from "../../services/exportApi";
import { useToast } from "../../context/ToastContext";
import { Card } from "../../components/common/Card";
import { Button } from "../../components/common/Button";
import { DataTable } from "../../components/common/DataTable";

export function FeedingsTab({ hive, feedings, onLogged }) {
  const { notify } = useToast();
  const [catalog, setCatalog] = useState([]);
  const [form, setForm] = useState({ feeding_id: "", quantity: "", date: new Date().toISOString().slice(0, 10) });
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    feedingsApi.listCatalog().then((r) => setCatalog(r.feedings));
  }, []);

  async function submit() {
    if (!form.feeding_id || !form.quantity) return notify("Choose a feeding type and quantity", "warning");
    try {
      await feedingsApi.log(hive.hive_id, { feeding_id: Number(form.feeding_id), quantity: Number(form.quantity), date: form.date });
      notify("Feeding logged", "success");
      onLogged?.();
    } catch (err) {
      notify(err.apiMessage || "Could not log feeding", "danger");
    }
  }

  async function exportCsv() {
    setExporting(true);
    try {
      await exportApi.feedingsCsv();
      notify("Feedings exported", "success");
    } catch (err) {
      notify(err.apiMessage || "Export failed", "danger");
    } finally {
      setExporting(false);
    }
  }

  return (
    <div>
      <Card
        title="Feeding History & Consumption"
        className="section-spacing"
        actions={<Button size="sm" variant="secondary" onClick={exportCsv} disabled={exporting}>{exporting ? "Exporting…" : "Export CSV"}</Button>}
      >
        <DataTable
          rows={feedings}
          rowKey="log_id"
          emptyTitle="No feedings logged"
          emptyDescription="Syrup, fondant and pollen substitute — what this colony has been given, and when."
          columns={[
            { key: "date", header: "Date", render: (r) => new Date(r.date).toLocaleDateString() },
            { key: "feeding_id", header: "Type", render: (r) => catalog.find((c) => c.feeding_id === r.feeding_id)?.feeding_type || r.feeding_id },
            { key: "quantity", header: "Quantity" },
            { key: "consumption_rate", header: "Consumption Rate" },
          ]}
        />
      </Card>

      <Card title="Log Feeding">
        <div style={{ display: "grid", gap: "var(--space-3)", maxWidth: 360 }}>
          <select id="feedings-tab-feeding-id" name="feeding-id" value={form.feeding_id} onChange={(e) => setForm((f) => ({ ...f, feeding_id: e.target.value }))} className="touch-target">
            <option value="">Choose feeding…</option>
            {catalog.map((c) => <option key={c.feeding_id} value={c.feeding_id}>{c.feeding_type}</option>)}
          </select>
          <input id="feedings-tab-quantity" name="quantity" type="number" placeholder="Quantity" value={form.quantity} onChange={(e) => setForm((f) => ({ ...f, quantity: e.target.value }))} className="touch-target" />
          <input id="feedings-tab-date" name="date" type="date" value={form.date} onChange={(e) => setForm((f) => ({ ...f, date: e.target.value }))} className="touch-target" />
          <Button onClick={submit}>Log Feeding</Button>
        </div>
      </Card>
    </div>
  );
}
